import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import * as z from "zod";
import { TFunction } from "i18next";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";

const SignInSchema = z.object({
  success: z.literal(true),
  data: z.object({
    token: z.string(),
  }),
});
export interface MutateUserSignInParams {
  emailAddress: string;
  password: string;
}

export const mutateSignIn = async (values: MutateUserSignInParams) => {
  const response = await makeMutation(ApiEndpoints.signIn(), values, false, 'POST', signInErrorCodes);
  return SignInSchema.parse(response);
};

export const signInErrorCodes = {
  ...generalErrorCodes,
  INVALID_CREDENTIALS: {
    code: "INVALID_CREDENTIALS",
    translation: (t: TFunction) => t("Invalid credentials"),
  },
  USER_IS_NOT_ACTIVE_YET: {
    code: "USER_IS_NOT_ACTIVE_YET",
    translation: (t: TFunction) => t("User account isn't activated"),
  },
  USER_IS_DISABLED: {
    code: "USER_IS_DISABLED",
    translation: (t: TFunction) => t("User is disabled"),
  },
};
